import * as React from 'react'

import { Tabs } from '../tabs/Tabs'
import type { SegmentedControlTheme } from './SegmentedControl.types'
import type { SegmentedControlRootProps } from './SegmentedControlRoot'

export interface SegmentedControlContextValue extends Pick<
  React.ComponentProps<typeof Tabs>,
  'defaultValue' | 'value' | 'onValueChange'
> {
  size: SegmentedControlRootProps['size']
  theme: SegmentedControlTheme
}

export const SegmentedControlContext =
  React.createContext<SegmentedControlContextValue>({
    size: 'md',
    theme: 'primary',
    defaultValue: '',
    value: '',
    onValueChange: () => null
  })
